import { isProd } from './functions'

const STRIPE_TEST = 'pk_test_51PGQFXIFGpWpW0ag3bYlnGQzn9RVOJQechi695t3evQvus2GPe04AKk98lW5MDaeoNHLO5oSIXXAVIApwew10p1q00xEBINkov'

const GTM_DEV = 'GTM-TXLBMZK' 
// const GTM_PROD = 'GTM-WXDQNMP'
const GTM_PROD = 'GTM-5C6M8SZB'

export const googleApiKey = 'AIzaSyBg0mrIV1PDFJ91rhIAQt7xGhlafQzGS90'

export const stripeApiKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || STRIPE_TEST
export const gtmID = isProd() ? GTM_PROD : GTM_DEV
